import type { Blueprint, NextExamPrediction } from './types';

const TOP_CONCEPTS = 4;

/** The blueprint patch that applies a prediction: chapter counts plus each chapter's hints. */
export function predictionPatch(p: NextExamPrediction): Partial<Blueprint> {
  const chapters = p.chapters.filter(c => c.predicted > 0);
  const patch: Partial<Blueprint> = {
    chapter_distribution: chapters.map(c => ({
      chapter_id: c.chapter_id,
      count: c.predicted,
      difficulty_override: null,
      concepts: c.concepts.slice(0, TOP_CONCEPTS).map(x => x.name),
      ...(c.difficulty ? { difficulty_pct: c.difficulty } : {}),
      avoid: c.avoid,
    })),
  };
  if (p.difficulty) {
    patch.difficulty_mode = 'mixed';
    patch.difficulty_pct = p.difficulty;
  }
  return patch;
}

export const yearsLabel = (years: Array<number | null>) => {
  const ys = years.filter((y): y is number => y != null);
  if (ys.length === 0) return '';
  const lo = Math.min(...ys); const hi = Math.max(...ys);
  return lo === hi ? String(lo) : `${lo}–${hi}`;
};
